var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.price)?_c('p',{staticClass:"text-xs text-gray-dark"},[_vm._v("\n  "+_vm._s(_vm.formattedPrice)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }